import * as React from "react";
import { Table } from "../../newcomponents/table/table";
import { ExternalLinkColumn } from "../../newcomponents/table/columns/generic/externalLink";
import { TableProps } from "../../newcomponents/table/types";
import { FormItem } from "../antd/form/FormItem";

interface TagLinksTableItem {
  key: string;
  value: string;
}
interface Props extends Omit<TableProps<TagLinksTableItem>, "title" | "data" | "columns"> {
  tags: TagLinksTableItem[];
}

export const TagLinksTable: React.FC<Props> = ({ tags, ...tableProps }) => {
  return (
    <FormItem>
      <Table<any>
        title={() => <div>Tag Links</div>}
        styles={{ header: { marginBottom: 0 } }}
        data={tags}
        hideSettings
        columns={[
          { id: "key", label: "Key", enableResize: true, size: 200 },
          ExternalLinkColumn({ id: "value", label: "Value", enableResize: true, size: 200 }),
        ]}
        {...tableProps}
      />
    </FormItem>
  );
};
